import { Lab } from 'typings/laboratory'
import { create } from 'zustand'

interface LaboratoryLogoType {
    currentLaboratory: Lab | undefined
    setCurrentLaboratory: (currentLaboratory: Lab | undefined) => void
}

export const useLaboratoryLogo = create<LaboratoryLogoType>(set => ({
    currentLaboratory: undefined,
    setCurrentLaboratory: (currentLaboratory: Lab | undefined) => set(() => ({ currentLaboratory })),
}))
